module.exports = __webpack_public_path__ + "img/ki.e7816d17.svg";